import { render } from "./FooterLink.vue?vue&type=template&id=40bd130e"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricardo/Sites/customizer/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__